import React from 'react';
import { Avatar } from '@mui/material';
import { TeamsInterface } from 'ts-interfaces';
import { getAvatarColor, getAvatarText, getDisplayName, getUrlFromRef } from '../utils/ShareResourceUtils';

interface MemberAvatarProps {
  member: TeamsInterface;
}

export const MemberAvatar: React.FC<MemberAvatarProps> = ({ member }) => {
    if (!member || !member.uid) return null;
    return (
    <Avatar
      sx={{
        bgcolor: member.profile_pic ? 'transparent' : getAvatarColor(member.uid),
        color: 'white',
        fontWeight: 'bold'
      }}
    >
      {member.profile_pic ? (
        <img 
          src={getUrlFromRef(member.profile_pic)} 
          alt={getDisplayName(member)} 
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}  
        />
      ) : (
        getAvatarText(member)
      )}
    </Avatar>
  );
};